import { Component } from '@angular/core';
import { SharedComponentsModule } from '../shared-components.module';
import { MandantLogoModule } from '../shared/mandant-logo/mandant-logo.module';

@Component({
  selector: 'app-under-construction',
  standalone: true,
  imports: [MandantLogoModule],
  templateUrl: './under-construction.component.html',
  styleUrl: './under-construction.component.scss'
})
export class UnderConstructionComponent {

}
